import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Status } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-status",
	imports: [COMMON_IMPORTS, GenInputComponent, CancelBtnComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./status.component.html",
})
export class StatusComponent extends Modalable {
	userId: number = 0
	Text: string = ""
	fields: string[] = [
		"generalDescription",
		"consciousness",
		"orientation",
		"affect",
		"thoughtProcess",
		"thinking_content",
		"suicidality",
		"delusions",
		"hallucinations",
		"judgement",
		"insight",
		"intelligence",
		"memory",
		"reality_check",
	]
	sendObj: Status = new Status() //object to hold all the updated field values and return to the component that opened THIS modal

	ngOnInit() {
		//when called to open
		this.userId = this.store.cc()?.user_id
		this.fields.forEach((field) => {
			//reset the sendObj fields to be their lang default (besides content - is empty)
			this.sendObj[field] =
				field == "thinking_content" ? "" : this.lang.getVal(field + "_desc")
		})
	}

	returnText() {
		//gather al fields in a text block and return it to the component that opened THIS modal
		let title = this.lang.getVal("status") + ": "
		if (this.userId == 1351) {
			this.Text =
				"<br>" +
				title +
				this.fields
					.map((field) => this.lang.getVal(field) + ": " + this.sendObj[field])
					.join(", ") //joins all labels and fields
		} else {
			this.Text =
				"<br>" +
				title +
				"<br>" +
				this.fields
					.map((field) => this.lang.getVal(field) + ": " + this.sendObj[field])
					.join("<br> ") //joins all labels and fields
		}

		this.onClose.emit(this.Text) //close and return the text block
	}
}
